module.exports = __webpack_public_path__ + "static/media/dog9.3576fce8.jpeg";